<script>
import api from '@utils/api'

export default {
  name: 'GoodsCharacteristicItemNew',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    goodsId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      newItem: {
        goods: Number(this.goodsId),
        characteristic: null,
        value: null,
      },
      rules: {
        goods: [x => !!x || this.$t('validation__is_required')],
        characteristic: [x => !!x || this.$t('validation__is_required')],
        value: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    isOil() {
      return this.$route.params.goodsItem.group === 1
    },
    goods() {
      return this.$store.getters['data/getDictionary']('goods')
    },
    characteristic() {
      const unusedCharacteristics = [119, 120, 121]
      return this.$store.getters['data/getDictionary']('characteristic').filter(
        elem => !unusedCharacteristics.includes(elem.code)
      )
    },
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    isVolume() {
      return this.newItem.characteristic === 114
    },
    unitsMeasurementHint() {
      if (!this.newItem.characteristic) return ''
      if (
        this.newItem.characteristic === 120 ||
        (this.newItem.characteristic >= 107 &&
          this.newItem.characteristic <= 110)
      )
        return ''
      if (this.newItem.characteristic === 121) return 'label__g_to_cm'
      return this.newItem.characteristic === 114
        ? `label__${this.unitsMeasurement.volumeMeasure}`
        : `label__${this.unitsMeasurement.lengthMeasure}`
    },
  },
  mounted() {
    if (this.isOil) {
      this.newItem.characteristic = 121
    }
  },
  methods: {
    closeItem() {
      this.$refs.newForm.reset()
      this.newItem.goods = Number(this.goodsId)
      this.newItem.characteristic = this.isOil ? 121 : null
      this.$emit('new-canceled')
    },
    createItem() {
      if (this.$refs.newForm.validate()) {
        this.loading = true
        if (this.isOil) {
          const item = {
            density15c: parseFloat(this.newItem.value.replace(',', '.')),
          }
          api
            .createSubItem('goods', this.goodsId, 'oilcharacts', item)
            .then(resoponse => {
              this.$emit('new-item-created')
              this.$refs.newForm.reset()
              this.newItem.goods = Number(this.goodsId)
              this.loading = false
            })
            .catch(() => {})
            .then(() => {
              this.loading = false
            })
        } else {
          let value
          if (
            this.newItem.characteristic > 110 &&
            this.newItem.characteristic <= 121
          ) {
            value = parseFloat(this.newItem.value.replace(',', '.'))
            if (this.newItem.characteristic === 114) {
              value *= this.unitsMeasurement.volumeMultiplier
            } else if (this.newItem.characteristic === 121) {
              value /= this.unitsMeasurement.densityMultiplier
            } else if (this.newItem.characteristic !== 120) {
              value *= this.unitsMeasurement.lengthMultiplier
            }
          } else {
            value = this.newItem.value
          }
          api
            .createGoodsCharacteristic({
              ...this.newItem,
              value,
            })
            .then(resoponse => {
              this.$emit('new-item-created')
              this.$refs.newForm.reset()
              this.newItem.goods = Number(this.goodsId)
              this.loading = false
            })
            .catch(() => (this.loading = false))
        }
      }
    },
  },
}
</script>

<template>
  <v-dialog
    :value="dialog"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <div class="headline">{{ $t('titles__new_goods_characteristic') }}</div>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-form
                ref="newForm"
                v-model="valid"
                lazy-validation
              >
                <v-select
                  :items="goods"
                  :label="$t('label__goods')"
                  v-model="newItem.goods"
                  :rules="rules.goods"
                  item-text="shortName"
                  item-value="id"
                  required
                  autocomplete
                  readonly
                />
                <v-select
                  :items="characteristic"
                  :label="$t('label__characteristic')"
                  v-model="newItem.characteristic"
                  :rules="rules.characteristic"
                  :readonly="isOil"
                  item-text="name"
                  item-value="code"
                  required
                  autocomplete
                />
                <v-text-field
                  :label="$t('label__value')"
                  v-model="newItem.value"
                  :rules="rules.value"
                  :type="isOil ? 'number' : 'text'"
                  :hint="$t(unitsMeasurementHint)"
                  persistent-hint
                  name="value"
                  required
                  autocomplete="off"
                />
              </v-form>
              <small>* {{ $t('label__requier_small_text') }}</small>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click="closeItem">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :loading="loading"
          :disabled="loading"
          type="submit"
          color="primary"
          @click="createItem">{{ $t('buttons__create') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.btnWrapper {
  margin-top: 26px;
  margin-left: -8px;
}
</style>
